import Account from "../../../../assets/user/Account";
import Dashboard from "../../../../assets/user/Dashboard";
import KYC from "../../../../assets/user/KYC";
import Withdraw from "../../../../assets/user/wallet/Withdraw";
import Transfer from "../../../../assets/user/Transfer";
import Tutorial from "../../../../assets/user/Tutorial";
import Transaction from "../../../../assets/user/Transaction";
import Support from "../../../../assets/user/Support";
import Faq from "../../../../assets/user/Faq";
import EmailTemplate from "../../../../assets/user/inbox";
import MyTeam from "../../../../assets/ib/MyTeam";
import Disc from "../../../../assets/user/Disc";
import Reports from "../../../../assets/user/Reports";
import Download from "../../../../assets/Download";
import Deposit from "../../../../assets/user/wallet/Deposit";
import LeaderBoard from "../../../../assets/leaderboard";

export const SidebarData = [
  {
    title: "Dashboard",
    icon: <Dashboard />,
    url: "/dashboard",
    activeUrl: ["/dashboard"],
    // kycApproval: true
  },
  {
    title: "Client Profile",
    icon: <Transaction />,
    url: "/client_profile",
    activeUrl: ["/client_profile"],
    unAuth: true,
  },
  // {
  //     title: 'Inbox',
  //     icon: <EmailTemplate />,
  //     url: '/inbox',
  //     activeUrl: ['/inbox'],
  //     kycApproval: true
  // },
  {
    title: "Accounts",
    icon: <Account />,
    url: "/accounts",
    activeUrl: ["/accounts", "/account"],
    kycApproval: true,
  },
  // {
  //     title: 'Deposit',
  //     icon: <Withdraw />,
  //     url: '/deposit',
  //     activeUrl: ['/deposit', '/deposit_usdt'],
  //     kycApproval: true
  // },
  // {
  //     title: 'Withdraw',
  //     icon: <Withdraw />,
  //     url: '/withdraw',
  //     activeUrl: ['/withdraw'],
  //     kycApproval: true
  // },
  // {
  //     title: 'Wallet',
  //     icon: <Withdraw />,
  //     activeUrl: [],
  //     kycApproval: true,
  //     child: [
  //         {
  //             title: 'Withdraw',
  //             icon: <Disc />,
  //             url: '/withdraw',
  //             activeUrl: ['/withdraw'],
  //         },
  //         {
  //             title: 'Deposit',
  //             icon: <Disc />,
  //             url: '/deposit',
  //             activeUrl: ['/deposit'],
  //         },
  //     ],
  // },
  {
    title: "Deposit",
    icon: <Deposit />,
    url: "/deposit",
    activeUrl: ["/deposit"],
  },
  {
    title: "Withdraw",
    icon: <Withdraw />,
    url: "/withdraw",
    activeUrl: ["/withdraw"],
  },
  {
    title: "Internal Transfer",
    icon: <Transfer />,
    url: "/transfer",
    activeUrl: ["/transfer"],
    kycApproval: true,
  },
  {
    title: "Download App",
    icon: <Download />,
    url: "/download",
    activeUrl: ["/download"],
  },
  {
    title: "My Transaction",
    icon: <Transaction />,
    url: "/my_transaction",
    activeUrl: ["/my_transaction"],
    kycApproval: true,
  },
  // {
  //     title: 'Perent Tree',
  //     icon: <MyTeam />,
  //     url: '/perent_tree',
  //     activeUrl: ['/perent_tree'],
  //     kycApproval: true
  // },

  {
    title: "Reports",
    icon: <Reports />,
    activeUrl: [],
    kycApproval: true,
    child: [
      {
        title: "Deposit",
        icon: <Disc />,
        url: "/deposit_Report",
        activeUrl: ["/deposit_Report"],
      },
      {
        title: "Withdraw",
        icon: <Disc />,
        url: "/withdrawal_Report",
        activeUrl: ["/withdrawal_Report"],
      },
      {
        title: "InternalTransfer",
        icon: <Disc />,
        url: "/transfer_Report",
        activeUrl: ["/transfer_Report"],
      },
      {
        title: "Logs",
        icon: <Disc />,
        url: "/logs",
        activeUrl: ["/logs"],
      },
    ],
  },
  {
    title: "Leaderboard",
    icon: <LeaderBoard />,
    url: "/leaderboard",
    activeUrl: ["/leaderboard"],
  },
  {
    title: "KYC",
    icon: <KYC />,
    url: "/kyc",
    activeUrl: ["/kyc"],
    unAuth: true,
  },
  {
    title: "Tutorial",
    icon: <Tutorial />,
    url: "/tutorials",
    activeUrl: ["/tutorials"],
  },

  {
    title: "Support",
    icon: <Support />,
    url: "/support",
    activeUrl: ["/support", "/view_ticket"],
  },
  {
    title: "FAQs",
    icon: <Faq />,
    url: "/faq",
    activeUrl: ["/faq"],
  },
];
